import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Auth from "@/pages/Auth";

export const Route = createFileRoute("/auth")({
  head: () => seoHead("/auth"),
  component: Auth,
});
